import React from "react";
import { FieldWrapper } from "../../components/FieldWrapper";
import { DueInventoryItem, Width } from "../configurables";
import { ISubfields } from "../interfaces/ISubfields";
import { TableRow } from "./TableRow";

export class DateTableRow extends TableRow implements ISubfields {
    public subfields = [];
    public label = "Datum";
    public icon = "calendar";
    public fieldType = "Datum";
    public attributeNames = ["monthYearOnly"];

    public getConfigurables() {
        return [Width, DueInventoryItem];
    }

    public toHotColumn(): {} {
        return {
            type: "date",
            monthYearOnly: !!(this as any).monthYearOnly,
            dueInventoryItem: this.rawOptions
                ? (this.rawOptions as any).dueInventoryItem
                : undefined,
        };
    }

    public EditComponent({ schema, designer, field, entry = null, register }) {
        return (
            <FieldWrapper designer={designer} schema={schema} field={field}>
                <label>Überschrift</label>
                <input
                    type={field.designerInputType}
                    name={field.inputName("label")}
                    className="form-control"
                    defaultValue={field.label}
                    ref={register}
                />
                <label className="d-flex align-items-center mt-3">
                    <input
                        type="checkbox"
                        name={field.inputName("monthYearOnly")}
                        defaultChecked={field.monthYearOnly}
                        ref={register}
                        style={{ width: 40 }}
                    />
                    Nur Monat/Jahr (z.B. 10/2030)
                </label>
            </FieldWrapper>
        );
    }
}
